/*
 * Copyright Elasticsearch B.V. and/or licensed to Elasticsearch B.V. under one
 * or more contributor license agreements. Licensed under the Elastic License
 * 2.0; you may not use this file except in compliance with the Elastic License
 * 2.0.
 */

// DO NOT MODIFY THIS FILE BY HAND. IT IS GENERATED BY
// `yarn workspace @elastic/esql-definitions generate` FROM
// `elasticsearch/esql/x-pack-esql/definition/functions/st_geohex.json`.

import type { FunctionDefinition } from '../../definition_types';

/**
 * Calculates the `geohex`, the H3 cell-id, of the supplied geo_point at the specified precision.
 * The result is long encoded.
 * Use `TO_STRING`
 * to convert the result to a string,
 * `TO_LONG`
 * to convert it to a `long`, or
 * `TO_GEOSHAPE`
 * to calculate the `geo_shape` bounding geometry.
 *
 * These functions are related to the `geo_grid` query
 * and the `geohex_grid` aggregation.
 *
 * @example
 * FROM airports
 * | EVAL geohex = ST_GEOHEX(location, 1)
 * | STATS
 *     count = COUNT(geohex),
 *     centroid = ST_CENTROID_AGG(location)
 *       BY geohex
 * | WHERE count >= 10
 * | EVAL geohexString = TO_STRING(geohex)
 * | KEEP count, centroid, geohexString
 * | SORT count DESC, geohexString ASC
 */
const definition: FunctionDefinition = {
  type: 'scalar',
  name: 'st_geohex',
  signatures: [
    {
      params: [
        {
          name: 'geometry',
          type: 'geo_point',
          optional: false,
        },
        {
          name: 'precision',
          type: 'integer',
          optional: false,
          hint: {
            kind: 'constant',
          },
        },
      ],
      variadic: false,
      returnType: 'geohex',
      license: 'PLATINUM',
    },
    {
      params: [
        {
          name: 'geometry',
          type: 'geo_point',
          optional: false,
        },
        {
          name: 'precision',
          type: 'integer',
          optional: false,
          hint: {
            kind: 'constant',
          },
        },
        {
          name: 'bounds',
          type: 'geo_shape',
          optional: true,
          hint: {
            kind: 'constant',
          },
        },
      ],
      variadic: false,
      returnType: 'geohex',
      license: 'PLATINUM',
    },
  ],
  preview: true,
  snapshotOnly: false,
  license: 'PLATINUM',
};

export default definition;
